import React from 'react';
import { Box, Typography } from '@mui/material';
import './category_button.scss';
import allIcon from '../../../assets/all.png';
import groceryIcon from '../../../assets/grocery.png';
import apparelIcon from '../../../assets/apparel.png';
import electronicsIcon from '../../../assets/electronics.png';
import autoIcon from '../../../assets/auto.png';
import footwearIcon from '../../../assets/footwear.png';

interface CategoryButtonProps {
  selected: string;
  onSelect: (categoryName: string, categoryId: number) => void;  
  userRole?: string; 
}

const categories = [
  { name: 'All', icon: allIcon, id: 0 },
  { name: 'Groceries', icon: groceryIcon, id: 16 },
  { name: 'Fashion', icon: apparelIcon, id: 18 },
  { name: 'Electronics', icon: electronicsIcon, id: 19 },
  { name: 'Auto Parts', icon: autoIcon, id: 20 },
  { name: 'Footwear', icon: footwearIcon, id: 17 },
];

const CategoryButton: React.FC<CategoryButtonProps> = ({ selected, onSelect, userRole }) => {
  return (
    <Box 
      className={`category-container ${userRole === "vendor_supervisor" ? "vendor-supervisor" : ""}`}
    >
      {categories.map((category) => (
        <Box
          key={category.name}
          className={`category-button ${selected === category.name ? 'selected' : ''}`}
          onClick={() => onSelect(category.name, category.id)} 
        >
          <img src={category.icon} alt={category.name} className="category-icon" />
          <Typography className="category-label">{category.name}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CategoryButton;
